export default {
    isAuth: (state) => state.user && state.user.uid ? true : false,
    user: (state)  => state.user && state.user.uid ? state.user : {}
}